import { postConsumption } from 'core/crud/contents.crud';
import { putJob } from 'core/crud/jobs.crud';
import { useTranslate } from 'core/hooks/useTranslate';
import { useCourse } from 'core/lite/hooks/useCourse';
import { successResponse } from 'core/utils/utils';
import { useEffect, useState } from 'react';
import { getEmbedUrl } from '../../../utils/regex/urls';

export default function useIframeViewer({ url, title, contentGuid, jobGuid, courseGuid }) {
  const { t } = useTranslate();
  const { data: course } = useCourse(courseGuid);
  const [embedUrl, setEmbedUrl] = useState(null);
  const [origin, setOrigin] = useState(null);

  useEffect(() => {
    setEmbedUrl(getEmbedUrl(url));
    setOrigin(getUrlOrigin(url));
  }, [url]);

  async function initConsumption(contentGuid) {
    const consumptions = await postConsumption({ content_guid: contentGuid, progress_ends: 1, type: 'link' });
    if (successResponse(consumptions)) {
      const newConsumption = consumptions.data.data;
      updateJobStatusProgress(newConsumption, jobGuid);
    }
  }

  async function updateJobStatusProgress(data, jobGuid) {
    if (data && jobGuid) {
      putJob(jobGuid, {
        progress: 1,
        status: 'delivered',
      });
    }
  }

  async function openLink() {
    if (contentGuid && jobGuid && course?.isReadOnly === false) {
      await initConsumption(contentGuid);
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function getUrlOrigin(url) {
    // Validate that url is a valid non-empty string
    if (!url || typeof url !== 'string' || url.trim() === '') {
      console.warn('IframeViewer: Invalid URL provided to getUrlOrigin:', url);
      return null;
    }

    try {
      const urlObject = new URL(url);
      return urlObject.hostname;
    } catch (error) {
      console.error('IframeViewer: Failed to parse URL:', url, error);
      return null;
    }
  }

  return {
    embedUrl,
    // Sin dominio la URL no es válida: el pie ya dice «URL no disponible» y no hay nada que abrir.
    hasOpenLinkButton: Boolean(title && origin),
    iframeTitle: title || origin,
    openLink,
    openLinkLabel: t('common:Open file in new tab', { name: title }),
    origin,
    originLabel: origin || t('ui:URL not available'),
  };
}
